import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { growlErrors } from '../../../utils/NotificationUtil';
import { Loading } from '../../../components/Loading';
import { withGrowl } from '../../../components/GrowlNotifications';

import NewSurveyProjectFormContainer from './NewSurveyProjectFormContainer';
import { getEntityListWithAccount } from '../../../utils/AppUtil';
import { withAccount } from '../../../components/AccountContext';
import { growlShape } from '../../../components/prop-types';


export const SURVEY_TEMPLATES = gql`
  query surveyTemplates($accountId: ID!, $first: Int) {
    account(id: $accountId) {
      id
      surveyTemplates(first: $first) {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
`;

const NewSurveyProjectContainer = (props) => {
  const { growl, currentAccount } = props;

  const variables = {
    accountId: currentAccount,
    first: 200,
  };

  return (
    <Query query={SURVEY_TEMPLATES} variables={variables}>
      {({ loading, error, data }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          growlErrors(growl, error);
        }

        const { account } = data;

        const surveyTemplates = getEntityListWithAccount(account, 'surveyTemplates');

        return (
          <NewSurveyProjectFormContainer
            accountId={currentAccount}
            templates={surveyTemplates}
          />
        );
      }}
    </Query>
  );
};

NewSurveyProjectContainer.propTypes = {
  growl: growlShape.isRequired,
  currentAccount: PropTypes.string.isRequired,
};

export default withAccount(
  withGrowl(
    NewSurveyProjectContainer,
  ),
);
